import React from "react";
import { assets } from "../assets/assets";

export const BillTemplate = ({ orderItem, product, userInfo, currency,orderId }) => {
  const subtotal = product.price * orderItem.quantity;
  const deliveryFee = orderItem.delivery_fee || 10;
  const total = subtotal + deliveryFee;
  return (
    <div id="invoice-section" className="bg-white p-6 rounded-lg shadow max-w-lg mx-auto">
      <div className="flex items-center mb-4">
        <img src={assets.logo} alt="Logo" className="h-12 w-12 mr-3" />
        <div>
          <div className="font-bold text-xl text-gray-900">Sahla Curtain Center</div>
          <div className="text-gray-600 text-sm">Order Invoice</div>
        </div>
      </div>
      <div className="flex justify-between mb-2">
        <div>
          <div className="text-gray-700 text-sm">Invoice ID:</div>
          <div className="font-mono text-blue-700">{orderId}</div>
          <div className="text-gray-700 text-sm mt-1">Date:</div>
          <div className="font-mono">{new Date(orderItem.date).toLocaleDateString()}</div>
        </div>
        <div className="text-right">
          <div className="text-gray-700 font-semibold">Customer:</div>
          <div className="text-gray-900">{userInfo?.name || orderItem.address?.firstName + ' ' + orderItem.address?.lastName}</div>
          <div className="text-gray-600 text-sm">{userInfo?.email || orderItem.address?.email}</div>
          <div className="text-gray-600 text-sm">{orderItem.address?.phone}</div>
          <div className="text-gray-600 text-sm">{orderItem.address?.street}, {orderItem.address?.city}, {orderItem.address?.state}, {orderItem.address?.zipCode}, {orderItem.address?.country}</div>
        </div>
      </div>
      <hr className="my-2" />
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-left">
          <thead>
            <tr className="bg-gray-100">
              <th className="py-2 px-3 font-semibold">Product</th>
              <th className="py-2 px-3 font-semibold">Category</th>
              <th className="py-2 px-3 font-semibold">Subcategory</th>
              <th className="py-2 px-3 font-semibold">Size</th>
              <th className="py-2 px-3 font-semibold">Color</th>
              <th className="py-2 px-3 font-semibold">Qty</th>
              <th className="py-2 px-3 font-semibold">Unit Price</th>
              <th className="py-2 px-3 font-semibold">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="py-2 px-3">{product.name}</td>
              <td className="py-2 px-3">{product.category}</td>
              <td className="py-2 px-3">{product.subCategory}</td>
              <td className="py-2 px-3">{orderItem.size}</td>
              <td className="py-2 px-3">
                {orderItem.color && (
                  <span className="inline-block w-4 h-4 rounded-full border border-gray-300 mr-1 align-middle" style={{ backgroundColor: orderItem.color }}></span>
                )}
                {orderItem.color}
              </td>
              <td className="py-2 px-3">{orderItem.quantity}</td>
              <td className="py-2 px-3">{currency}{product.price}</td>
              <td className="py-2 px-3 font-semibold">{currency}{subtotal.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="flex justify-end mt-4">
        <div className="w-full sm:w-1/2 md:w-1/3">
          <div className="flex justify-between py-1">
            <span className="text-gray-700">Subtotal:</span>
            <span className="font-semibold">{currency}{subtotal.toFixed(2)}</span>
          </div>
          <div className="flex justify-between py-1">
            <span className="text-gray-700">Delivery Fee:</span>
            <span>{currency}{deliveryFee.toFixed(2)}</span>
          </div>
          <div className="flex justify-between py-1 border-t mt-2">
            <span className="text-gray-900 font-bold">Total:</span>
            <span className="text-gray-900 font-bold">{currency}{total.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
